module.exports = __webpack_public_path__ + "static/img/img13.35311e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img13.png
// module id = bLos
// module chunks = 1